var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaBestattungBeratung(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#141414;}.cls-3{fill:#3c3c3c;}.cls-4{fill:#eceff5;}.cls-5{font-size:45.3px;fill:#009bd9;font-family:Arvo-Bold, Arvo;font-weight:700;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.62 142.77 81.78 47.26 69.78 41.12 8 130.32 14.62 142.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "86.11 142.77 18.95 47.26 30.95 41.12 92.73 130.32 86.11 142.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,47.26c0-12.53,10-28.83,31.41-28.83s31.42,16.3,31.42,28.83l-12-6.14s12-13.78-19.42-13.78S31,41.12,31,41.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.72,25.2C22.34,31.09,16.16,39.5,19,47.26l12-6.14s-2.76-4.72-3.12-8.72A12,12,0,0,1,29.72,25.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71,25.2c7.38,5.89,13.56,14.3,10.77,22.06l-12-6.14s2.76-4.72,3.12-8.72A12,12,0,0,0,71,25.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.76,65.43a31,31,0,1,0-50.07,2L96,81.9a2.35,2.35,0,0,0,3.34,2.24L112.47,78A31,31,0,0,0,146.76,65.43Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(112.26 64.84)"
  }, "i")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaBestattungBeratung);
export default __webpack_public_path__ + "static/media/ka_bestattung-beratung.f4aa06d33dc468845f5df312e7ff5590.svg";
export { ForwardRef as ReactComponent };